import { inject, Service } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Userpilot } from "userpilot";
import { ConfigurationService } from "@/shared-module/services/configuration.service";

@Service()
export class PageService {
  private http = inject(HttpClient);
  private configurationService = inject(ConfigurationService);


  get(id: string) {
    this.configurationService.refreshConfig();
    Userpilot.track("Open page", {
      url: `api/page/${id}`,
    });
    return this.http.get<string>(`api/page/${id}`).pipe((s) => {
      return s;
    });
  }

  getpath(
    id: string,
    path: string = null,
    subpath: string = null,
    prms: any = null,
  ) {
    this.configurationService.refreshConfig();
    if (subpath !== null) {
      Userpilot.track("Open page", {
        url: `api/page/${id}/${path}/${subpath}`,
      });
      return this.http
        .get<string>(`api/page/${id}/${path}/${subpath}`, { params: prms })
        .pipe((s) => {
          return s;
        });
    }
    if (path !== null) {
      Userpilot.track("Open page", {
        url: `api/page/${id}/${path}`,
      });
      return this.http
        .get<string>(`api/page/${id}/${path}`, { params: prms })
        .pipe((s) => {
          return s;
        });
    }
    Userpilot.track("Open page", {
      url: `api/page/${id}`,
    });
    return this.http
      .get<string>(`api/page/${id}`, { params: prms })
      .pipe((s) => {
        return s;
      });
  }
}
